/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useCallback, useState } from 'react'
import AnTable from '../../components/AnTable/index'
import { sortHelper } from '../../helpers/misc/sortHelper'
import { isAdminUser } from '../../helpers/users'
import { removeColumnsByTitle } from '../../helpers/utils'
import { getUsers, EditUser } from './helper'
import UserInfo from '../UserInfo/index'
import Loading from '../Loading'

const userManagement = () => {
    const [ready, setReady] = useState<boolean>(false)
    const [columsToShow, setColumnsToShow] = useState<any>([])
    const [usersData, setUsersData] = useState<{}[] | any>([])
    const [isOnEdit, setIsOnEdit] = useState<boolean>(false)
    const [recordData, setRecordData] = useState<any>([])

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'name',
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            key: 'name',
        },
        {
            title: 'User email',
            dataIndex: 'email',
            sorter: (a: [], b: []) => sortHelper(a, b, 'email'),
            key: 'email',
        },
        {
            title: 'Company',
            dataIndex: 'company',
            sorter: (a: [], b: []) => sortHelper(a, b, 'email'),
            key: 'company',
        },
        {
            title: 'Role',
            dataIndex: 'role',
            sorter: (a: [], b: []) => sortHelper(a, b, 'role'),
            key: 'role',
        },
        {
            title: 'Last Login Time',
            dataIndex: 'lastLogin',
            sorter: (a: [], b: []) => sortHelper(a, b, 'lastLogin'),
            key: 'lastLogin',
        },
        {
            title: 'Last Update',
            dataIndex: 'lastUpdated',
            sorter: (a: [], b: []) => sortHelper(a, b, 'lastUpdated'),
            key: 'lastUpdated',
        },
        /* {
            title: 'Created By',
            dataIndex: 'createdBy',
            sorter: (a: [], b: []) => sortHelper(a, b, 'createdBy'),
            key: 'createdBy',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            sorter: (a: [], b: []) => sortHelper(a, b, 'status'),
            key: 'status',
            render:(st: string) => (
                <div className='status-wrapper'>
                    <span className={'status-indicator ' + (st === 'Inactive' ? 'deactivated' : 'active')}></span>
                    <p>{st}</p>
                </div>
            )
        }, */
        /* {
            title: 'Action',
            dataIndex: 'status',
            key: 'status',
            align: 'center' as 'center',
            render:(status: string, record: any) => (
                <PopUp 
                trigger='click'
                color='white'
                placement="bottomRight"
                opts={
                    [
                        { title:'Edit', action: (e) => { EditUser(e, setIsOnEdit); setRecordData(record) } },
                        { title: status === 'Inactive' ? 'Activate' : 'Deactivate', action: (e) => userActions(e, status, record, setUsersData) },
                        {title:'Delete', action:DeleteUser},
                    ]
                } />
            )
        }, */
        {
            title: 'Action',
            dataIndex: 'status',
            key: 'status',
            align: 'center' as 'center',
            render:(status: string, record: any) => (
                <div onClick={(e) => { EditUser(e, setIsOnEdit); setRecordData(record)}} >
                    <p style={{ color: 'rgb(6, 120, 157)', cursor: 'pointer' }}>Edit</p>
                </div>
            )
        },
    ]

    const init = useCallback(async () => {
        const isAdmin = await isAdminUser()
        // if is not admin, removing the selected column
        if (!isAdmin) removeColumnsByTitle({
                columns, 
                toBeRemoved: ['action']
            })

        //  CNT-2064 - no any user should be allow to edit the users from content suite
        /* removeColumnsByTitle({
            columns, 
            toBeRemoved: ['action']
        }) */

        // forming the columns to show
        setColumnsToShow(columns)
        // get User Info
        const data: { users: {}[] } | any = await getUsers()
        // set the userData
        setUsersData(data?.users)
        // set the view as active
        setReady(true)
    }, [columns])

    useEffect(() => {
        init()
    },[])

    useEffect(() => {
        init()
    }, [isOnEdit])

    return (
        <>
        {
            !ready && <div style={{ paddingLeft: '50%' }}> <Loading type="large" /> </div>
        }
        { ready && !isOnEdit &&
            <AnTable
                data = {usersData}
                configuration = {columsToShow}
                onCLickRow = {()=>{}} 
                search= {{label: 'Search', placeholder: 'Search User name/User email/Role'}}
            />
        }
        {
            ready && isOnEdit && <UserInfo record={recordData} setIsOnEdit={setIsOnEdit} />
        }
        </>
    )
}

export default userManagement
